import { EditOutlined } from '@ant-design/icons';
import { Button, Spin } from 'antd';
import Title from 'components/layout/Title';
import { useCallback, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { signoutAsync } from 'stores/auth/authSlice';
import { REQUEST_STATUSES } from 'stores/common';
import { useAppDispatch, useAppSelector } from 'stores/hooks';
import { useUser } from 'stores/user/userHooks';
import { getPatchUserRequestStatus } from 'stores/user/userSlice';
import AccountInformationsStepper from './new-account/AccountInformationsStepper';

export default function NewAccount() {
  const dispatch = useAppDispatch();
  const patchUserRequestStatus = useAppSelector(getPatchUserRequestStatus);
  const [editMode, setEditMode] = useState(false);
  const [user] = useUser();
  const onClickEdit = useCallback(() => setEditMode(true), []);
  const onClickSignOut = useCallback(() => dispatch(signoutAsync()), [dispatch]);

  useEffect(() => {
    if (user && !user.completed) {
      setEditMode(true);
    }
  }, [user]);

  useEffect(
    () => {
      if (patchUserRequestStatus === REQUEST_STATUSES.SUCCESS) {
        setEditMode(false);
      }
    },
    [patchUserRequestStatus],
  );

  if (!user) {
    return (
      <div className='flex flex-col items-center justify-center grow'>
        <Spin />
      </div>
    );
  }

  if (user.activated) {
    return (
      <Navigate
        to='/'
        replace
      />
    );
  }

  return (
    <div>
      <div className='h-24 mt-6'>
        {!user?.completed && (
          <Title className='text-center'>
            Finalisez votre inscription
          </Title>
        )}
        {user?.completed && (
          <Title className='text-center'>
            {'Votre compte est en attente de validation par les équipes d\'Hapni'}
          </Title>
        )}
        {patchUserRequestStatus === REQUEST_STATUSES.SUCCESS && (
          <Title
            main
            className='text-lg text-center'
          >
            Vos informations ont bien été enregistrées
          </Title>
        )}
      </div>
      {editMode && <AccountInformationsStepper user={user} />}
      {!editMode && (
        <div className='mt-12 text-center'>
          <Button
            size='large'
            onClick={onClickEdit}
            className='!inline-flex !items-center mb-12'
          >
            <EditOutlined />
            Editer mes informations
          </Button>
        </div>
      )}
      <div className='text-center'>
        <Button
          onClick={onClickSignOut}
          type='link'
          danger
        >
          Se déconnecter
        </Button>
      </div>
    </div>
  );
}
